import { createFileRoute } from "@tanstack/react-router";

import EditProfile from "@/pages/user/edit-profile";

export const Route = createFileRoute("/@{$username}/edit-profile")({
  component: EditProfilePage,
  head: () => ({ meta: [{ title: "Edit profile" }] }),
});

function EditProfilePage() {
  return <EditProfile />;
}
